import { notNull } from 'utils/notNull';
import { useSiteInfo } from './useSiteInfo';

// может быть использовать только в компонентах, где гарантируется наличие siteInfo.data –
// в тех, что находятся ниже UserLayout
export function useSiteInfoData() {
  const { data } = useSiteInfo();
  return notNull(data);
}
